import showSpinner from '@services/addSpinnerOnQueryStarted';
import appendPath, { toQueryString } from '@services/path';

const BASE_PATH = 'api/v1/employee/Utilities';
const appendToApiPath = appendPath(BASE_PATH);

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<Dto.IPriorityTimeRemainingQueryModel, any, any, {number: number}[]>}
 */
const getPriorityRemainingTime = (builder) => builder.query({
    query: (queryParams) => ({ url: `${appendToApiPath('getPriorityRemainingTime')}${toQueryString(queryParams)}`, method: 'GET' }),
    async onQueryStarted(id, api) { await showSpinner(api); },
});

const endpointsEmployeeUtilities = (builder) => ({
    getPriorityRemainingTime: getPriorityRemainingTime(builder),
});

export default endpointsEmployeeUtilities;
